import React from 'react';

import { WidgetSlotConfiguration } from '@/api/rest/resources/types/widget';

// eslint-disable-next-line import/no-cycle
import { WidgetSlotRenderer } from '../WidgetSlotRenderer';

export const ConfigurationFromHookRenderer =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (configurationHook?: (props?: any) => WidgetSlotConfiguration | null): React.FC<any> =>
    // eslint-disable-next-line react/display-name
    (props) => {
      const configuration = configurationHook?.(props);
      if (!configuration) {
        return null;
      }
      return <WidgetSlotRenderer nestedWidget={configuration} />;
    };
